import { AFFILIATE_TRANSACTIONS } from '../actionTypes';

export const fetchAffiliateTransactions = (action) => ({
  type: AFFILIATE_TRANSACTIONS.FETCH,
  payload: action.payload,
});
